import React from 'react';
import { UtensilsIcon, ShuffleIcon, FlameIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <UtensilsIcon className="w-8 h-8 text-rose-500" data-id="element-131" />,
    title: '1. Elegí una base',
    desc: 'Arroz, pasta, huevos, pollo... lo que tengas en la heladera. No necesitás compras especiales.'
  }, {
    icon: <ShuffleIcon className="w-8 h-8 text-rose-500" data-id="element-132" />,
    title: '2. Combiná con lo que hay',
    desc: 'El sistema te dice qué va con qué. Sin inventar, sin dudar. Combinaciones probadas que funcionan.'
  }, {
    icon: <FlameIcon className="w-8 h-8 text-rose-500" data-id="element-133" />,
    title: '3. Ejecutá en minutos',
    desc: 'Sartén, horno o airfryer. Técnicas simples para que la comida esté lista mientras ponés la mesa.'
  }];
  return <section className="py-20 bg-white" data-id="element-134">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl lg:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-137">
            Así funciona el Sistema Cocina Sin Estrés™
          </h2>
          <p className="text-xl text-gray-600" data-id="element-138">
            No necesitás pensar. Solo seguir 3 pasos.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-139">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-orange-100 -z-10 transform -translate-y-1/2" data-id="element-140"></div>

          {steps.map((step, idx) => <div key={idx} className="flex flex-col items-center text-center bg-white p-6 rounded-2xl md:bg-transparent" data-id="element-141">
              <div className="w-24 h-24 bg-orange-50 rounded-full flex items-center justify-center mb-6 border-4 border-white shadow-sm relative z-10" data-id="element-142">
                {step.icon}
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-rose-500 rounded-full flex items-center justify-center text-white font-bold text-sm" data-id="element-143">
                  {idx + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-144">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-145">{step.desc}</p>
            </div>)}
        </div>

        <div className="mt-12 text-center bg-orange-50 p-6 rounded-xl max-w-3xl mx-auto border border-orange-100" data-id="element-146">
          <p className="text-gray-800 font-medium" data-id="element-147">
            <span className="font-bold text-rose-500" data-id="element-148">Por qué funciona:</span>{' '}
            No buscás recetas sueltas en Google. Seguís un sistema que ya
            decidió por vos.
          </p>
        </div>
      </div>
    </section>;
}